import { ChannelBusinessHealthMetric, ChannelBusinessHealthMetrics } from '../types';

/** First matching metric key with a finite `current` value. */
const pickChannelMetricRow = (
    metrics: ChannelBusinessHealthMetrics,
    keys: string[],
): ChannelBusinessHealthMetric | undefined => {
    const rowKey = (keys ?? []).find((key) => {
        const row = metrics[key];
        return row != null && Number.isFinite(row.current);
    });
    return rowKey ? metrics[rowKey] : undefined;
};

export default pickChannelMetricRow;
